import { ExtendedBrightcovePlayer } from '../../../types';

export function getPercentageWatched({
  player,
}: {
  player: ExtendedBrightcovePlayer | null;
}): number {
  let totalTimeWatched = 0;

  if (player !== null) {
    const consumedSeconds = player.consumedSeconds();
    const playerDuration = player.duration();
    totalTimeWatched = Math.ceil((consumedSeconds / playerDuration) * 100);
  }
  return totalTimeWatched;
}
